import React from "react";
import { Heading } from "@abyss/web/ui/Heading";
import { GreyCta } from "../GreyCta";
import { V2Badge } from "@abyss/web/ui/Badge";
import { V2Button } from "@abyss/web/ui/Button";
import { V2Link } from "@abyss/web/ui/Link";
import { AddItems } from "@src/components/AddItems";
import { IconSymbol } from "@abyss/web/ui/IconSymbol";
import { QuoteBox } from "@src/components/QuoteBox";

import classNames from "classnames";

import styles from "./plansection.module.css";

export const RegularListing = ({ item }) => {
  return (
    <div className={styles.tierWrap}>
      <div className={styles.tierItems}>
        {item.costs.map((col, index) => {
          return (
            <React.Fragment>
              {col.sectionBreak && (
                <div className={styles.isFull}>
                  <div className={styles.sectionBreakHeading}>
                    {col.sectionBreak}
                  </div>
                </div>
              )}
              <div
                className={classNames(
                  styles.tierItem,
                  col.type === "full" ? styles.isFull : ""
                )}
              >
                {col.tier && (
                  <div className={styles.tierPill}>
                    <V2Badge variant="info">{col.tier}</V2Badge>
                  </div>
                )}

                <div className={styles.tierTitle}>{col.tierTitle}</div>

                {col.listings.map((listing, index) => {
                  return (
                    <div
                      dangerouslySetInnerHTML={{ __html: listing }}
                      className={styles.scripSection}
                    />
                  );
                })}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export const ScripListing = ({ item }) => {
  return (
    <div className={styles.tierWrap}>
      <div className={styles.tierItems}>
        {item.costs.map((col, index) => {
          return (
            <div className={styles.tierItem}>
              <div className={styles.tierPill}>
                <V2Badge variant="info">{col.tier}</V2Badge>
              </div>
              <div className={styles.tierTitle}>{col.tierTitle}</div>
              <div
                dangerouslySetInnerHTML={{ __html: col.top }}
                className={styles.scripSection}
              />
              <div
                dangerouslySetInnerHTML={{ __html: col.bottom }}
                className={styles.scripSection}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const DocumentsListing = ({ item }) => {
  return (
    <div className={styles.docWrap}>
      <div className={styles.docItems}>
        {item.areas.map((doc, index) => {
          return (
            <div className={styles.docSection}>
              <div className={styles.tierTitle}>{doc.title}</div>
              {doc.items.map((zed, index) => {
                return (
                  <div className={styles.docItem}>
                    {zed.icon === "pdf" && (
                      <V2Button variant="text" className={styles.pdflink}>
                        <img src="/assets/icons/pdf.png" alt="pdf icon" />{" "}
                        {zed.item}
                      </V2Button>
                    )}
                    {zed.icon === "link" && (
                      <V2Link
                        href="#"
                        openNewWindow
                        className={styles.external}
                      >
                        {zed.item}
                      </V2Link>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const PlanSection = ({ parent, items, layout, key }) => {
  return (
    <div
      className={classNames(
        styles.planCard,
        { [styles.ms]: parent === "ms" },
        { [styles.isPushed]: layout }
      )}
      id={items.value}
      data-section
    >
      <div className={styles.planHead}>
        <div>
          <Heading.Level>
            <Heading className={styles.title}>
              <IconSymbol
                icon={items.icon}
                size="24px"
                color="$primary1"
                variant="outlined"
              />
              <span>{items.title}</span>
            </Heading>
          </Heading.Level>
        </div>
      </div>

      {/* Doctor Visits */}
      {items.value === "doctor_visits" && (
        <React.Fragment>
          <div className={styles.section}>
            <div className={styles.intro}>
              <div className={styles.description}>{items.description}</div>
              <div>
                <AddItems type="doctors" />
              </div>
            </div>
            <div className={styles.body}>
              <RegularListing item={items} />
            </div>
          </div>
          <section>
            <div>
              <GreyCta />
            </div>
          </section>
        </React.Fragment>
      )}

      {/* Medical Benefit */}
      {items.value === "medical-benefit" && (
        <React.Fragment>
          <div className={styles.section}>
            <div className={styles.body} style={{ marginTop: "30px" }}>
              <RegularListing item={items} />
            </div>
          </div>
        </React.Fragment>
      )}

      {/* Dental */}
      {items.value === "dental" && (
        <React.Fragment>
          <div className={styles.section}>
            <div className={styles.intro}>
              <div className={styles.description}>{items.description}</div>
              <div>
                <AddItems type="dentists" />
              </div>
            </div>
            <div className={styles.body}>
              <div className={styles.blueBox}>
                <div className={styles.blueBoxDentalContainer}>
                  <div className={styles.blueBoxDentalWrap}>
                    <div>
                      <div className={styles.blueBoxSubhead}>
                        Routine dental
                      </div>
                      <div className={styles.blueBoxTitle}>
                        $2,000 allowance
                      </div>

                      <div className={styles.blueBoxCopy}>
                        <span>For covered dental services</span>
                        <span>
                          You will have access to one of Medicare Advantage's
                          largest dental networks, or you can choose any
                          dentist.
                        </span>
                      </div>
                    </div>
                    <div
                      className={styles.blueBoxDesktopImg}
                      style={{ marginRight: "-22px", background: "#eef8fb" }}
                    >
                      <img
                        src="/assets/images/toothbrush_desktop.png"
                        alt="toothbrush"
                      />
                    </div>
                    <div className={styles.blueBoxMobileImg}>
                      <img
                        src="/assets/images/toothbrush-mobile.png"
                        alt="toothbrush"
                      />
                    </div>
                  </div>
                  <div className={styles.tierItems}>
                    <div className={styles.tierItem}>
                      <div className={styles.scripSection}>
                        <div>
                          <span>$0 copay</span>
                        </div>
                        <div>
                          For covered preventive and comprehensive services like
                          oral exams, cleanings, X-rays, fillings, crowns, root
                          canals, extractions.
                        </div>
                      </div>
                    </div>

                    <div className={styles.tierItem}>
                      <div className={styles.scripSection}>
                        <div>
                          <span>50% coinsurance</span>
                        </div>
                        <div>For bridges and dentures</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Testimonial Section */}
          <div className={styles.quoteBoxWrap}>
            <QuoteBox />
          </div>
        </React.Fragment>
      )}

      {/* Extra Benefits */}
      {items.value === "benefits" && (
        <React.Fragment>
          <div className={classNames(styles.section, styles.glassesContainer)}>
            <div className={styles.intro}>
              <div className={styles.description}>{items.description}</div>
            </div>
            <div className={styles.body}>
              <div
                className={classNames(styles.blueBox, styles.blueBoxGlasses)}
              >
                <div className={styles.blueBoxTitle}>
                  See the UnitedHealthcare plan difference
                </div>
                <div className={styles.blueBoxGlassesWrap}>
                  <div className={styles.glassesImg}>
                    <img src="/assets/images/glasses.png" alt="toothbrush" />
                  </div>
                  <div className={styles.blueBoxCopy}>
                    <span>
                      Free standard prescription lenses including single vision,
                      bifocals, trifocals and Tier 1 (standard) progressives
                    </span>
                    <span>
                      Access to one of Medicare Advantage’s largest national
                      networks of vision providers and retail networks.
                    </span>
                    <span>
                      Eyewear available from many online providers, including
                      Warby Parker, GlassesUSA and more.
                    </span>
                  </div>
                </div>
                <div className={styles.tierItems}>
                  <div className={styles.tierItem}>
                    <div className={styles.tierTitle}>Routine eye exam</div>

                    <div className={styles.scripSection}>
                      <div>
                        <span>$0 copay</span>
                      </div>
                      <div>1 per year*, In-network</div>
                    </div>
                    <div className={styles.scripSection}>
                      <div>
                        <span>$0 copay</span>
                      </div>
                      <div>Combined visits in and out-of-network</div>
                    </div>
                  </div>

                  <div className={styles.tierItem}>
                    <div className={styles.tierTitle}>Routine eyewear</div>

                    <div className={styles.scripSection}>
                      <div>
                        <span>up to $200</span>
                      </div>
                      <div>
                        every two years for 1 pair of frames or contact lenses.
                        Standard single, bifocal, trifocal, or progressive
                        lenses are covered in full. Home-delivered eyewear
                        available nationwide only through UnitedHealthcare
                        Vision (select products only).
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={classNames(styles.blueBox, styles.blueBoxHearing)}
              >
                <div className={styles.blueBoxTitle}>
                  Hearing sounds better with more access
                </div>
                <div className={styles.blueBoxHearingWrap}>
                  <div className={styles.hearingImg}>
                    <img src="/assets/images/hearing.png" alt="hearing" />
                  </div>
                  <div className={styles.blueBoxCopy}>
                    <span>
                      Choose from a broad selection of OTC and brand-name
                      prescription hearing aids through UnitedHealthcare
                      Hearing, up to 2 hearing aids every year.*
                    </span>
                    <span>
                      Access to one of the largest national networks of hearing
                      professionals with more than 7,000 locations.
                    </span>
                  </div>
                </div>
                <div className={styles.tierItems}>
                  <div className={styles.tierItem}>
                    <div className={styles.tierTitle}>Routine hearing exam</div>

                    <div className={styles.scripSection}>
                      <div>
                        <span>$0 copay</span>
                      </div>
                      <div>1 per year*, In-network</div>
                    </div>
                    <div className={styles.scripSection}>
                      <div>
                        <span>$55 copay</span>
                      </div>
                      <div>Combined visits in and out-of-network</div>
                    </div>
                  </div>

                  <div className={styles.tierItem}>
                    <div className={styles.tierTitle}>Hearing aids</div>

                    <div className={styles.scripSection}>
                      <div>
                        <span>$99-$1,249 copay </span>
                      </div>
                      <div>
                        For each hearing aid through UnitedHealthcare Hearing,
                        up to 2 hearing aids every year.*
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.hearingNeeds}>
                <Heading.Level>
                  <Heading className={styles.hearingNeedsTitle}>
                    Get more for your everyday needs
                  </Heading>
                </Heading.Level>

                <div className={styles.hearingNeedsLoop}>
                  {items.needs.map((need, index) => {
                    return (
                      <div className={styles.need}>
                        <div
                          className={classNames(
                            styles.needIcon,
                            styles[need.icon]
                          )}
                        >
                          <img
                            src={`/assets/images/${need.icon}.png`}
                            alt={need.icon}
                          />
                        </div>
                        <div className={styles.needHeadings}>
                          <div className={styles.needSub}>{need.sub}</div>
                          <div className={styles.needTitle}>{need.title}</div>
                        </div>
                        <div className={styles.needDescriptionWrap}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: need.description,
                            }}
                            className={styles.needDescription}
                          />
                          {need.link && (
                            <V2Link
                              href="#"
                              openNewWindow
                              className={styles.external}
                            >
                              {need.link}
                            </V2Link>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div
                  className={classNames(styles.tierItems, styles.benefitTiers)}
                  style={{ marginTop: "30px" }}
                >
                  <div className={styles.tierItem}>
                    <div className={styles.tierTitle}>Routine foot care</div>

                    <div className={styles.scripSection}>
                      <div>
                        <span>$30 copay</span>
                      </div>
                      <div>6 visits per year, In-network</div>
                    </div>
                    <div className={styles.scripSection}>
                      <div>
                        <span>$55 copay</span>
                      </div>
                      <div>Combined visits in and out-of-network</div>
                    </div>
                  </div>

                  <div className={styles.tierItem}>
                    <div className={styles.tierTitle}>Meal benefit</div>

                    <div className={styles.scripSection}>
                      <div>
                        <span>$0 copay </span>
                      </div>
                      <div>
                        For 28 home-delivered meals immediately after an
                        inpatient hospitalization or skilled nursing facility
                        (SNF) stay.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}

      {/* Prescriptions */}
      {items.value === "prescriptions" && (
        <React.Fragment>
          <div className={styles.section}>
            <div className={styles.intro}>
              <div
                className={classNames(styles.description, styles.scripDescrip)}
              >
                {items.description}
              </div>
              <div>
                <AddItems type="drugs" />
              </div>

              <div className={styles.deduct}>
                <div className={styles.deductHead}>
                  Annual prescription deductible
                </div>
                <div className={styles.deductCost}>
                  <div>
                    <span>$0</span>
                    <span>for Tiers 1 - 2</span>
                  </div>
                  <div>
                    <span>$340</span>
                    <span>for Tiers 3 - 5</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.body}>
              <RegularListing item={items} />
            </div>
          </div>
        </React.Fragment>
      )}

      {/* Plan Documents */}
      {items.value === "documents" && (
        <React.Fragment>
          <div className={styles.section}>
            <div className={styles.intro}>
              <div className={styles.description}>{items.description}</div>

              <div className={styles.docLang}>
                <div className={styles.docLangTitle}>Language</div>
                <div className={styles.docLangButtons}>
                  <V2Button size="$md">English</V2Button>
                  <V2Button size="$md" variant="secondary">
                    Other languages
                  </V2Button>
                </div>
              </div>
            </div>
            <div className={styles.body}>
              <DocumentsListing item={items} />
            </div>
          </div>
        </React.Fragment>
      )}

      {/* Footnotes */}
      {items.value === "footnotes" && (
        <React.Fragment>
          <div className={styles.section}>
            <div className={styles.body}>
              <div className={styles.footnote}>
                <div>
                  1 The amount shown does not include the Part B premium you
                  already pay to the government. Your plan costs, including
                  premiums and drug costs, may be different if you get Extra
                  Help from the government or if you have Medicaid. For more
                  information, see "Can I Get Help with my Medicare Prescription
                  Drug Costs?."
                </div>

                <div>
                  Benefits, premium and/or copayments/coinsurance may change on
                  January 1 of each year.
                </div>

                <div>
                  2 Amounts may vary depending on the level of care provided or
                  the type of health care services you receive.
                </div>

                <div>
                  3 Benefits, features and/or devices may vary by plan/area.
                  Limitations and exclusions apply. See the Summary of Benefits
                  (PDF) in the Plan Documents section for details.
                </div>

                <div>
                  4 Benefits, features and/or devices may vary by plan/area.
                  Limitations and exclusions apply. See the Evidence of Coverage
                  (PDF) in the Plan Documents section for details.
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};
